import variables from "@/utils/variables";

export default function formatBusiness(v) {
  for (let t of variables.orderAreaType) {
    if (v == t.value) {
      return t.text;
    }
  }

  return;
}
